import ModalUpdate from './ModalUpdate';

export { ModalUpdate } from './ModalUpdate'
export default ModalUpdate;



// WEBPACK FOOTER //
// ./src/components/TaskTable/RowTable/ModalUpdate/index.js